/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TwitchClipItem
 */
export interface TwitchClipItem {
    /**
     * 
     * @type {string}
     * @memberof TwitchClipItem
     */
    clipId?: string;
    /**
     * 
     * @type {string}
     * @memberof TwitchClipItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof TwitchClipItem
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof TwitchClipItem
     */
    embedUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TwitchClipItem
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof TwitchClipItem
     */
    viewCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TwitchClipItem
     */
    creatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof TwitchClipItem
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof TwitchClipItem
     */
    duration?: number;
    /**
     * 
     * @type {string}
     * @memberof TwitchClipItem
     */
    broadcasterName?: string;
}

/**
 * Check if a given object implements the TwitchClipItem interface.
 */
export function instanceOfTwitchClipItem(value: object): value is TwitchClipItem {
    return true;
}

export function TwitchClipItemFromJSON(json: any): TwitchClipItem {
    return TwitchClipItemFromJSONTyped(json, false);
}

export function TwitchClipItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TwitchClipItem {
    if (json == null) {
        return json;
    }
    return {
        
        'clipId': json['clipId'] == null ? undefined : json['clipId'],
        'title': json['title'] == null ? undefined : json['title'],
        'url': json['url'] == null ? undefined : json['url'],
        'embedUrl': json['embedUrl'] == null ? undefined : json['embedUrl'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'viewCount': json['viewCount'] == null ? undefined : json['viewCount'],
        'creatorName': json['creatorName'] == null ? undefined : json['creatorName'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'broadcasterName': json['broadcasterName'] == null ? undefined : json['broadcasterName'],
    };
}

export function TwitchClipItemToJSON(json: any): TwitchClipItem {
    return TwitchClipItemToJSONTyped(json, false);
}

export function TwitchClipItemToJSONTyped(value?: TwitchClipItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clipId': value['clipId'],
        'title': value['title'],
        'url': value['url'],
        'embedUrl': value['embedUrl'],
        'thumbnailUrl': value['thumbnailUrl'],
        'viewCount': value['viewCount'],
        'creatorName': value['creatorName'],
        'createdAt': value['createdAt'],
        'duration': value['duration'],
        'broadcasterName': value['broadcasterName'],
    };
}

